var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.onHideToasty = exports.onAddToasty = exports.hideToasty = exports.addToasty = void 0;
const getEventEmitter_1 = __importDefault(require("../getEventEmitter"));
const EVENT_EMITTER_ID = 'henderson-toasty-event-emitter';
var Events;
(function (Events) {
    Events["NEW_NOTIFICATION"] = "henderson-toasty-new-notification-event";
    Events["HIDE_NOTIFICATION"] = "henderson-toasty-hide-notification-event";
})(Events || (Events = {}));
const eventEmitter = (0, getEventEmitter_1.default)(EVENT_EMITTER_ID);
function addToasty(toasty) {
    eventEmitter.emit(Events.NEW_NOTIFICATION, toasty);
}
exports.addToasty = addToasty;
function hideToasty(toasty) {
    eventEmitter.emit(Events.HIDE_NOTIFICATION, toasty);
}
exports.hideToasty = hideToasty;
function onAddToasty(handler) {
    return eventEmitter.subscribe(Events.NEW_NOTIFICATION, handler);
}
exports.onAddToasty = onAddToasty;
function onHideToasty(handler) {
    return eventEmitter.subscribe(Events.HIDE_NOTIFICATION, handler);
}
exports.onHideToasty = onHideToasty;
//# sourceMappingURL=events.js.map